var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraFillDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.7007H10.9093L8.597 12.3541C8.40009 12.3921 8.20039 12.4132 8 12.4173C5.9675 12.4173 4.25 10.6742 4.25 8.61151C4.25 8.40524 4.27925 8.20429 4.31225 8.00563L0.608 4.24631C0.5405 4.41985 0.5 4.60786 0.5 4.80575V13.1784C0.5 14.018 1.17275 14.7007 2 14.7007ZM14 3.28345H12.0605L10.0302 1.22302C9.96072 1.1522 9.87808 1.09603 9.78707 1.05776C9.69607 1.01949 9.59851 0.999856 9.5 1H6.5C6.40149 0.999856 6.30393 1.01949 6.21293 1.05776C6.12192 1.09603 6.03928 1.1522 5.96975 1.22302L3.9395 3.28345H3.8105L1.78025 1.22302L0.71975 2.29929L14.2197 16L15.2803 14.9237L14.8107 14.4473C15.0214 14.3116 15.195 14.1242 15.3155 13.9024C15.4359 13.6806 15.4994 13.4316 15.5 13.1784V4.80575C15.5 3.96621 14.8273 3.28345 14 3.28345ZM10.016 9.58121C10.167 9.28074 10.2471 8.94878 10.25 8.61151C10.25 7.37388 9.2195 6.32806 8 6.32806C7.658 6.32806 7.337 6.41939 7.0445 6.56554L5.9495 5.45426C6.55372 5.03485 7.26798 4.80895 8 4.80575C10.0325 4.80575 11.75 6.54879 11.75 8.61151C11.7469 9.35441 11.5243 10.0793 11.111 10.6925L10.016 9.58121Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraFillDisable);
export default __webpack_public_path__ + "static/media/icon-camera-fill-disable.e94544cb7166c28a19f0b1dc11f40139.svg";
export { ForwardRef as ReactComponent };